export const UserType =  Object.freeze({
    INDUSTRY: 1,
    REGULATORY: 2,
    LIVE_CORP: 3
});